import { render, staticRenderFns, recyclableRender, components } from "./fetchData.vue?vue&type=template&id=5484999e&"
var renderjs
import script from "./fetchData.vue?vue&type=script&lang=js&"
export * from "./fetchData.vue?vue&type=script&lang=js&"
import style0 from "./fetchData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/index/fetchData.vue"
export default component.exports